module.exports = __webpack_public_path__ + "img/background.acf3ef65.webp";